export const clinicalReminderTriggers = [
  "next_visit",
  "post_test",
  "post_procedure",
  "follow_up_date",
] as const;
export type ClinicalReminderTrigger = (typeof clinicalReminderTriggers)[number];

export const clinicalReminderSeverities = ["info", "important", "critical"] as const;
export type ClinicalReminderSeverity = (typeof clinicalReminderSeverities)[number];

export const clinicalReminderStatuses = [
  "active",
  "acknowledged",
  "resolved",
  "cancelled",
] as const;
export type ClinicalReminderStatus = (typeof clinicalReminderStatuses)[number];

export const clinicalReminderTriggerLabels: Readonly<
  Record<ClinicalReminderTrigger, string>
> = {
  next_visit: "다음 내원",
  post_test: "검사 후",
  post_procedure: "시술 후",
  follow_up_date: "추적일",
};

export interface ClinicalReminderView {
  id: string;
  patientId: string;
  sourceEncounterId: string;
  trigger: ClinicalReminderTrigger;
  ruleCode: string;
  title: string;
  detail: string;
  severity: ClinicalReminderSeverity;
  status: ClinicalReminderStatus;
  dueAt: string | null;
  createdAt: string;
  acknowledgedAt: string | null;
}

export interface PatientRemindersResponse {
  patientId: string;
  reminders: ClinicalReminderView[];
}

export interface RunAiCheckResponse {
  encounterId: string;
  generated: number;
  reminders: ClinicalReminderView[];
  checkedAt: string;
  mode: "deterministic_preview";
}

export interface AcknowledgeReminderResponse {
  reminder: ClinicalReminderView;
}

export function isClinicalReminderTrigger(
  value: unknown,
): value is ClinicalReminderTrigger {
  return clinicalReminderTriggers.some((candidate) => candidate === value);
}

export function isClinicalReminderSeverity(
  value: unknown,
): value is ClinicalReminderSeverity {
  return clinicalReminderSeverities.some((candidate) => candidate === value);
}

export function isClinicalReminderStatus(
  value: unknown,
): value is ClinicalReminderStatus {
  return clinicalReminderStatuses.some((candidate) => candidate === value);
}
